module.exports = __webpack_public_path__ + "avatar_all.c5a509acee8aab3a1f62.png";


//////////////////
// WEBPACK FOOTER
// D:/taile-operate/BLACK-WIDOW/ng-src/assets/img/landing/avatar_all.png
// module id = ../../../../../ng-src/assets/img/landing/avatar_all.png
// module chunks = styles